export const siteSettings = {
  name: "Hexacod",
  link: "https://hexacod.net",
  email: "support@hexacod.net",
  appLink: "https://app.hexacod.net",
};
